export var directions = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
export var skins = {
  light: 'light',
  dark: 'dark',
  standard: 'standard',
  warning: 'warning',
  destructive: 'destructive',
  success: 'success',
  premium: 'premium'
};